import {
  Body3,
  Box,
  Color,
  Display,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react';
import { PricingDTOTypes } from '@repo/experience-api-client';

const BODY_3_SIZE = 2;

type Props = {
  options: PricingDTOTypes.PricingOptionDTO[];
  discountSteps: PricingDTOTypes.DiscountStepDTO[];
};

function buildFootnoteCopy({ options, discountSteps }: Props): string | null {
  const bestValueOption = options.find((option) => option.isBestValue);
  const firstDiscountStep = discountSteps[0];
  if (!bestValueOption || !firstDiscountStep) {
    return null;
  }
  return `*${bestValueOption.firstBoxPricePerPortion} per portion applies to a ${bestValueOption.numberOfPortions}-person, ${bestValueOption.numberOfRecipes}-recipe box with the ${firstDiscountStep.percentage} introductory discount applied, excluding delivery.`;
}

export function PricingFootnote({ options, discountSteps }: Props): JSX.Element | null {
  const copy = buildFootnoteCopy({ options, discountSteps });
  if (!copy) {
    return null;
  }

  return (
    <Box
      bg={Color.White}
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      paddingV={4}
      paddingH={10}
    >
      <Box maxWidth="640px">
        <Body3 size={BODY_3_SIZE} color={Color.ColdGrey_600} textAlign={TextAlign.Center}>
          {copy}
        </Body3>
      </Box>
    </Box>
  );
}
